module.exports = __webpack_public_path__ + "img/payment_received_icon.75ae2cdd.svg";